import { render, staticRenderFns } from "./catalog_reviews.vue?vue&type=template&id=0ebb5fbe&scoped=true&"
import script from "./catalog_reviews.vue?vue&type=script&lang=js&"
export * from "./catalog_reviews.vue?vue&type=script&lang=js&"
import style0 from "./catalog_reviews.vue?vue&type=style&index=0&id=0ebb5fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebb5fbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ebb5fbe')) {
      api.createRecord('0ebb5fbe', component.options)
    } else {
      api.reload('0ebb5fbe', component.options)
    }
    module.hot.accept("./catalog_reviews.vue?vue&type=template&id=0ebb5fbe&scoped=true&", function () {
      api.rerender('0ebb5fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/reviews/catalog_reviews.vue"
export default component.exports